import { PLANUNG_SCOPE } from '@bp/pim-auth-constants';
import { User } from 'oidc-client-ts';
import { FC, PropsWithChildren, useMemo } from 'react';
import { AuthProvider, AuthProviderProps } from 'react-oidc-context';

export const PlanungAuthProvider: FC<PropsWithChildren> = ({ children }) => {
  const oidcConfig: AuthProviderProps = useMemo(() => {
    return {
      onSigninCallback: (_user: User | void): void => {
        window.history.replaceState({}, document.title, window.location.pathname);
      },
      loadUserInfo: true,
      automaticSilentRenew: true,
      includeIdTokenInSilentSignout: false,
      includeIdTokenInSilentRenew: false,
      authority: import.meta.env.VITE_APP_AUTH_SERVER_URI,
      client_id: import.meta.env.VITE_APP_AUTH_CLIENT_ID,
      redirect_uri: import.meta.env.VITE_APP_REDIRECT_URI,
      post_logout_redirect_uri: import.meta.env.VITE_APP_LOGOUT_REDIRECT_URI,
      prompt: 'consent',
      scope: ['offline_access', 'openid', 'email', PLANUNG_SCOPE].join(' '),
    };
  }, []);

  return <AuthProvider {...oidcConfig}>{children}</AuthProvider>;
};
